import "./_section.scss";

import {ReactElement} from "react";

function Title({
  title,
  link = "#",
  linkTitle = "",
  linkLabel = "",
}: {
  title: string;
  link?: string;
  linkTitle?: string;
  linkLabel?: string;
}): ReactElement {
  return (
    <h1 className="title">
      <span>{title}</span>
      <a href={link} title={linkTitle}>
        {linkLabel}
      </a>
    </h1>
  );
}

export default Title;
